import { Product } from "@/types/models/product";
import { ProductFilters } from "@/services/productService";
import { createCrudSlice } from "@/utils/createCrudSlice";

// Create the product slice using the generic CRUD pattern
export const productSlice = createCrudSlice<Product, ProductFilters>({
  name: "products",
});

// Export actions
export const {
  // List operations
  fetchRequest: fetchProductsRequest,
  fetchSuccess: fetchProductsSuccess,
  fetchFailure: fetchProductsFailure,

  // Single item operations
  fetchItemRequest: fetchProductRequest,
  fetchItemSuccess: fetchProductSuccess,
  fetchItemFailure: fetchProductFailure,

  // Create operations
  createRequest: createProductRequest,
  createSuccess: createProductSuccess,
  createFailure: createProductFailure,

  // Update operations
  updateRequest: updateProductRequest,
  updateSuccess: updateProductSuccess,
  updateFailure: updateProductFailure,

  // Delete operations
  deleteRequest: deleteProductRequest,
  deleteSuccess: deleteProductSuccess,
  deleteFailure: deleteProductFailure,

  // Search operations
  searchRequest: searchProductsRequest,
  searchSuccess: searchProductsSuccess,
  searchFailure: searchProductsFailure,

  // Bulk operations
  bulkUpdateRequest: bulkUpdateProductsRequest,
  bulkUpdateSuccess: bulkUpdateProductsSuccess,
  bulkUpdateFailure: bulkUpdateProductsFailure,
  bulkDeleteRequest: bulkDeleteProductsRequest,
  bulkDeleteSuccess: bulkDeleteProductsSuccess,
  bulkDeleteFailure: bulkDeleteProductsFailure,

  // Utility operations
  clearCurrentItem: clearCurrentProduct,
  clearSearchResults: clearProductSearchResults,
  resetFormState: resetProductFormState,
  setSelectedIds: setSelectedProductIds,
} = productSlice.actions;

// Export reducer as default
export default productSlice.reducer;

// For backwards compatibility, export legacy actions
export const submitProductRequest = createProductRequest;
export const submitProductSuccess = createProductSuccess;
export const submitProductFailure = createProductFailure;

// Legacy status update actions (these will need to be mapped to the new update action)
export const updateProductStatus = (payload: { id: string; status: string }) => 
  updateProductRequest({ id: payload.id, updates: { status: payload.status } });

export const updateProductStatusSuccess = updateProductSuccess;
export const updateProductStatusFailure = updateProductFailure;
